import React from 'react';
import { Link } from 'react-router-dom';
import { BookOpen, Play, Clock, Check, ChevronRight, Home } from 'lucide-react';
import { Button } from '../ui/button';

export function CourseDetailView({ selectedCourse, lessons, setActiveLesson }) {
  return (
    <div className="p-8" data-testid="course-detail-view">
      <div className="flex items-center justify-between mb-6">
        <Link to="/dashboard/courses" className="inline-flex items-center gap-2 text-[#71717A] hover:text-white">
          <ChevronRight className="w-4 h-4 rotate-180" /> Back to Courses
        </Link>
        <Link to="/">
          <Button variant="outline" className="border-[#27272A] text-[#A1A1AA]" data-testid="back-home-btn">
            <Home className="w-4 h-4 mr-2" /> Back to Home
          </Button>
        </Link>
      </div>
      
      <div className="flex items-start gap-8 mb-8">
        <img 
          src={selectedCourse.image_url} 
          alt={selectedCourse.title} 
          className="w-48 h-32 object-cover rounded-md"
        />
        <div>
          <h1 className="text-3xl font-bold text-white mb-2" style={{ fontFamily: 'Chivo, sans-serif' }}>
            {selectedCourse.title}
          </h1>
          <p className="text-[#71717A] mb-4">{selectedCourse.description}</p>
          <div className="flex items-center gap-4 text-sm text-[#A1A1AA]">
            <span className="flex items-center gap-2">
              <BookOpen className="w-4 h-4" /> {lessons.length} lessons
            </span>
          </div>
        </div>
      </div>

      <h2 className="text-xl font-bold text-white mb-4" style={{ fontFamily: 'Chivo, sans-serif' }}>
        Course Lessons
      </h2>
      
      <div className="space-y-3">
        {lessons.map((lesson, index) => (
          <div 
            key={lesson.id}
            className="bg-[#141417] border border-[#27272A] rounded-md p-4 flex items-center gap-4 hover:border-[#007AFF]/50 transition-colors cursor-pointer"
            onClick={() => setActiveLesson(lesson)}
            data-testid={`lesson-${lesson.id}`}
          >
            <div className={`w-10 h-10 rounded-md flex items-center justify-center font-mono font-bold ${
              lesson.completed ? 'bg-[#00FF66]/10 text-[#00FF66]' : 'bg-[#007AFF]/10 text-[#007AFF]'
            }`}>
              {lesson.completed ? <Check className="w-5 h-5" /> : index + 1}
            </div>
            <div className="flex-1">
              <h3 className="text-white font-medium">{lesson.title}</h3>
              <div className="flex items-center gap-4 text-sm text-[#71717A]">
                <span className="flex items-center gap-1">
                  <Clock className="w-4 h-4" /> {lesson.duration}
                </span>
                {lesson.completed && <span className="text-[#00FF66]">Completed</span>}
              </div>
            </div>
            <Button className="btn-primary" data-testid={`watch-lesson-${lesson.id}`}>
              <Play className="w-4 h-4 mr-2" /> Watch
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
}
